module.exports = __webpack_public_path__ + "static/img/xiugaiyinliang.534a683.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/xiugaiyinliang.png
// module id = UbOF
// module chunks = 24